//src/components/ViewJobCard.jsx :-
import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Button,
  CircularProgress,
  Box,
  IconButton,
  Drawer,
  Menu,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";

import { ArrowForward, CheckCircle, MoreVert, ArrowBack, SaveAlt, Search } from "@mui/icons-material"; // Import MoreVert Icon
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { green, orange, red, grey, blue } from "@mui/material/colors";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import env from "react-dotenv";
import { useSelector } from 'react-redux';
import ExcelJS from 'exceljs'; // Import ExcelJS
import { saveAs } from 'file-saver'; // Import saveAs from file-saver

const getStatusColor = (status) => {
  switch (status) {
    case "inprogress":
      return orange[500];
    case "pending":
      return red[500];
    case "completed":
      return green[500];
    default:
      return grey[500];
  }
};

const ViewJobCard = () => {
  const { plan_id } = useParams();
  const navigate = useNavigate();
  const [fetchAssignedOperator, setFetchAssignedOperator] = useState([]);
  const [jobCards, setJobCards] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedCardDetails, setSelectedCardDetails] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null); // For dropdown menu
  const [operators, setOperators] = useState([]); // To store list of operators
  const [selectedOperator, setSelectedOperator] = useState(null); // To store selected operator
  const [selectedJobCard, setSelectedJobCard] = useState(null);
  // Get the latest step (last element in steps array)
  const latestStep = jobCards?.steps?.length ? jobCards.steps[jobCards.steps.length - 1] : null;
  const user = useSelector((state) => state.user);
  // const [userDetails, setUserDetails] = useState([]); // State to store user details
  const [userDetails, setUserDetails] = useState({}); // Initialize as an object
  const [allUsers, setAllUsers] = useState([]); // State to store all users
  const [selectedOperatorName, setSelectedOperatorName] = useState(""); // State to store selected operator's name
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdminForStep, setIsAdminForStep] = useState(false);
  const [jobCardHistory, setJobCardHistory] = useState([]); // State for job card history
  const [historyDrawerOpen, setHistoryDrawerOpen] = useState(false);
  const [filteredHistory, setFilteredHistory] = useState([]); // State for filtered history
  const [refreshTrigger, setRefreshTrigger] = useState(false); // Add refresh trigger state

  const [filters, setFilters] = useState({
    stepName: '',
    status: '',
    operator: '',
    startDate: null,
    endDate: null,
});
  
useEffect(() => {
  if (user && user.department) {
    const role = user.role?.toLowerCase();
    const department = user.department?.toLowerCase();
    
    // Check if user is Admin and department does not include Store or Supply
    const isAdminRole = role === 'admin' || role === 'operator' && !department.includes('supply');
    
    // Check if user is Super Admin
    const isSuperAdminRole = role === 'super admin';
    
    // Set isAdmin state
    setIsAdmin(isAdminRole || isSuperAdminRole);
  } else {
    setIsAdmin(false); // Reset if user or department is not defined
  }
}, [user]); // Re-run this effect whenever the user changes

useEffect(() => {
  if (user && user.department) {
    const role = user.role?.toLowerCase();
    const department = user.department?.toLowerCase();
    
    // Check if user is Admin and department does not include Store or Supply or Others
    const isAdminRole = role === 'admin' && !department.includes('supply') && !department.includes('store') && !department.includes('others');
    
    // Check if user is Super Admin
    const isSuperAdminRole = role === 'super admin';
    
    // Set isAdmin state
    setIsAdminForStep(isAdminRole || isSuperAdminRole);
  } else {
    setIsAdminForStep(false); // Reset if user or department is not defined
  }
}, [user]); // Re-run this effect whenever the user changes

  // console.log("User department :- ", user.department);
  // console.log("Job cards state:", jobCards); // Log the job cards state
  // console.log("Departments state:", departments); // Log the departments state
  
  // console.log("User department: ", userDetails.department);
  // console.log("User  Department:", userDetails.department);
  // console.log("All Users:", allUsers);
  // console.log("Is Admin:", isAdmin);
  // console.log("User  in Department:", allUsers.find(user => user.department.split(',').includes(userDetails.department)));
  
  // useEffect(() => {
  //   {jobCards.map((card) => (
  //     console.log("Current department: ", card.current_dept_name),
  //     console.log("User  is Admin or in Current Department:", isAdmin || userDetails.department.split(',').map(dept => dept.trim()).includes(card.current_dept_name))
  //   ))};
  // });

      // const userId = user?.id;/* Get the current user's ID from your auth context or state */;
      // const userDept = userDetails.department;
      // const userRole = userDetails.user_role;
      // console.log("Logged in user id : ", userId);
      // console.log("Logged in user dept : ", userDept);
      // console.log("Logged in user role : ", userRole);

  // useEffect(() => {
  //   if (!plan_id) {
  //     navigate('/production-tabs'); // Navigate to the home page if plan_id is not provided
  //   }
  // }, [plan_id, navigate]);

  const formatJobCardId = (card) => {
    const date = new Date(card.created_date); // Assuming created_date is the date field
    const month = date.toLocaleString('default', { month: '2-digit' }); // Get month in 2-digit format
    const year = date.getFullYear(); // Get the full year
    return `${month}/${year}/${card.product_name}/${card.job_card_id}`;
  };

  // useEffect(() => {
  //   const fetchAssignedOperators = async () => {
  //     try {
  //       const assignedResponse = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/job-card-history/assigned`);
  //       setFetchAssignedOperator(assignedResponse.data); // Store API data in state
  //       setLoading(false);
  //     } catch (err) {
  //       console.error("Error fetching assigned operator status:", err);
  //       setError("Failed to fetch assigned operator. Please check the server status or the API endpoint.");
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchAssignedOperators();
  // }, []);

  // Check if any step has `assigned_operator === "YES"`
  const isAssignedOperator = fetchAssignedOperator?.some((job) =>
    job.steps?.some((step) => step.assigned_operator === "YES")
  );

  // Fetch user details based on user ID
  const fetchUserDetails = async (userId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_USERMGMT_URL}/notes/${userId}`);
      setUserDetails(response.data); // Store user details in state
    } catch (error) {
      console.error("Error fetching user details:", error);
      setError("Failed to fetch user details");
    }
  };

  useEffect(() => {
    if (user?.id) {
      fetchUserDetails(user.id); // Fetch user details when user ID is available
    }
  }, [user]);

  const fetchAllUsers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_USERMGMT_URL}/notes`);
      setAllUsers(response.data); // Store all users in state
    } catch (error) {
      console.error("Error fetching user details:", error);
      setError("Failed to fetch user details");
    }
  };

  useEffect(() => {
    fetchAllUsers(); // Fetch all users when component mounts
  }, []);

  // Fetch job cards when refreshTrigger changes
  useEffect(() => {
    // if (plan_id) {
      const fetchJobCards = async () => {
        try {
          const jobCardResponse = await axios.get(
            `${process.env.REACT_APP_PJCBACKEND_URL}/api/job-cards?plan_id=${plan_id}`
          );
          // console.log("Job cards response:", jobCardResponse.data); // Log the response
          setJobCards(jobCardResponse.data);

          // Fetch departments based on product_id from job cards
          const productId = jobCardResponse.data[0]?.product_id; // Assuming all job cards have the same product_id
          // console.log("Product ID:", productId);
          const deptResponse = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-steps/departments/${productId}`);
          // console.log("All Departments from Production Steps:", deptResponse.data);

          // Access the first element of the response to get the department data
          setDepartments(deptResponse.data[0]); // Assuming the first element contains the department data

        } catch (err) {
          console.error("Error fetching data:", err); // Log the error
          setError("Failed to fetch data.");
        } finally {
          setLoading(false);
        }
      };
      fetchJobCards();
    // }
    // else {
    //   navigate('/production-tabs');
    // }
  }, [plan_id, refreshTrigger]); // Add refreshTrigger to dependencies

  const fetchJobCardHistory = async (jobCardId) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/job-card-history/details/${jobCardId}`);
    setJobCardHistory(response.data); // Set the fetched history
  } catch (error) {
    console.error("Error fetching job card history:", error);
    setError("Failed to fetch job card history.");
  }
};

// Function to get distinct steps
const getDistinctSteps = (history) => {
  const uniqueSteps = [];
  const stepNames = new Set();
  
  history.forEach(item => {
    if (!stepNames.has(item.step_name)) {
      stepNames.add(item.step_name);
      uniqueSteps.push(item);
    }
  });
  
  return uniqueSteps;
};
// Inside your component, after fetching jobCardHistory
const distinctHistory = getDistinctSteps(jobCardHistory);

const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const clearFilters = () => {
    setFilters({
      stepName: '',
      status: '',
      operator: '',
      startDate: '',
      endDate: '',
    });
    setFilteredHistory(distinctHistory); // Reset filtered history
  };

  useEffect(() => {
    const filtered = distinctHistory.filter((historyItem) => {
      const operatorName = allUsers.find(user => user.id === historyItem.operator_id)?.full_name || "Not assigned";
      const startDate = filters.startDate ? new Date(filters.startDate) : null;
      const endDate = filters.endDate ? new Date(filters.endDate) : null;
      const isWithinDateRange = (!startDate || new Date(historyItem.start_time) >= startDate) &&
                                (!endDate || new Date(historyItem.start_time) <= endDate);
      return (
        (historyItem.step_name.toLowerCase().includes(filters.stepName.toLowerCase()) || !filters.stepName) &&
        (historyItem.step_status.toLowerCase().includes(filters.status.toLowerCase()) || !filters.status) &&
        (operatorName.toLowerCase().includes(filters.operator.toLowerCase()) || !filters.operator) &&
        isWithinDateRange
      );
    });
    setFilteredHistory(filtered); // Update filtered history
  }, [filters, distinctHistory, allUsers]);

  const handleHistoryDrawerOpen = (jobCard) => {
    fetchJobCardHistory(jobCard.job_card_id); // Fetch history for the selected job card
    setHistoryDrawerOpen(true);
  };
  const handleHistoryDrawerClose = () => {
    setHistoryDrawerOpen(false);
    setJobCardHistory([]); // Clear history when closing the drawer
  };

  const handleDrawerOpen = (jobCard) => {
    setSelectedJobCard(jobCard);
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setSelectedDepartment("");
    setSelectedOperator("");
    setSelectedJobCard(null);
  };

//   const handleDepartmentChange = async (event) => {
//     const deptId = event.target.value;
//     setSelectedDepartment(deptId);
//     try {
//         const response = await axios.get(
//             `${process.env.REACT_APP_PJCBACKEND_URL}/api/operator/by-dept/${deptId}`
//         );
//         // Flatten the response if it's nested
//         // setOperators(response.data.flat()); // Use flat() to flatten the array
//         setOperators(response.data[0]);
//     } catch (error) {
//         console.error("Error fetching operators:", error);
//     }
// };

const handleDepartmentChange = (event) => {
  const deptName = event.target.value;
  setSelectedDepartment(deptName);

  // Filter operators based on the selected department and role
  const filteredOperators = allUsers.filter(user => 
    user.department === deptName && user.user_role === "Operator"
  );
  setOperators(filteredOperators);
};

const handleOperatorChange = (e) => {
  const operatorId = e.target.value;
  setSelectedOperator(operatorId);

  // Find the selected operator's full name from the operators array
  const operator = operators.find(op => op.id === operatorId);
  setSelectedOperatorName(operator ? operator.full_name : ""); // Set the selected operator's name
};

  // const handleAssignOperator = async () => {
  //   if (!selectedJobCard || !selectedDepartment || !selectedOperator) {
  //     alert("Please select all fields before assigning.");
  //     return;
  //   }

  //   try {
  //     await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/job-cards/assign-operator`, {
  //       job_card_id: selectedJobCard.job_card_id,
  //       dept_id: selectedDepartment,
  //       operator_id: selectedOperator,
  //     });

  //     // Update the job card state to reflect the changes
  //     setJobCards((prevJobCards) =>
  //       prevJobCards.map((card) =>
  //         card.job_card_id === selectedJobCard.job_card_id
  //           ? { ...card, operator_name: selectedOperator }
  //           : card
  //       )
  //     );

  //     alert("Operator assigned successfully!");
  //     window.location.reload();
  //     // handleDrawerClose();
  //   } catch (error) {
  //     console.error("Error assigning operator:", error);
  //     alert("Failed to assign operator.");
  //   }
  // };  

  const handleAssignOperator = async () => {
    if (!selectedJobCard || !selectedDepartment || !selectedOperator) {
      alert("Please select all fields before assigning.");
      return;
    }
  
    try {
      // const userName = user?.userName;
      const userId = user?.id;/* Get the current user's ID from your auth context or state */;
      const userDept = userDetails.department;
      const userRole = userDetails.user_role;

      const response = await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/assignment/assign`, {
        job_card_id: selectedJobCard.job_card_id,
        dept_name: selectedDepartment,
        operator_id: selectedOperator,
        user_id: userId,
        userDept: userDept,
        userRole: userRole,
      });

      if (response.status === 200) {
        alert("Operator assigned successfully!");
        setRefreshTrigger(prev => !prev); // Trigger refresh
         handleDrawerClose();
        navigate(`/view-job-card/${plan_id}`)
      }
  
      // Update the job card state to reflect the changes
      // setJobCards((prevJobCards) =>
      //   prevJobCards.map((card) =>
      //     card.job_card_id === selectedJobCard.job_card_id
      //       ? { ...card, operator_name: selectedOperator }
      //       : card
      //   )
      // );
  
      // alert("Operator assigned successfully!");
      // window.location.reload();
      // Close the drawer instead of reloading the window
      // handleDrawerClose();
      // navigate('/production-tabs');
      // setRefreshTrigger(prev => !prev); // Trigger refresh
      // handleDrawerClose(); // Close the drawer
      // navigate(`/view-job-card/${plan_id}`)
    } catch (error) {
      console.error("Error assigning operator:", error);
      alert("Do not have permission to assign this operator.");
    }
};

  const fetchOperators = async (dept_id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PJCBACKEND_URL}/api/operator/by-dept/${dept_id}`
      );
      // console.log('Fetched operators:', response.data); // Access data directly
      setOperators(response.data); // Update state with operator data
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };  

  const handleCardClick = (card) => {
    setSelectedCardDetails(card); // Save the selected card details
    // console.log("Selected Card Details: ", card); // Debugging purpose
  };  

  const handleArrowClick = (card, department, currentStepStatus) => {
    // Get all distinct operator IDs from current_dept_status
  const operatorIds = Array.from(
    new Set(
      card.current_dept_status
        .filter(operator => operator.operator_id) // Filter out any entries without an operator_id
        .map(operator => operator.operator_id) // Map to get an array of operator_ids
    )
  );
    // Find the matched user's full name
    // const operatorFullName = allUsers.find(user => user.id === card.current_dept_status.find(operator => operator.operator_id)?.operator_id)?.full_name || "";
    // Find the full names of the distinct operators
  const operatorFullName = operatorIds
    .map(id => allUsers.find(user => user.id === id)?.full_name) // Map to full names
    .filter(name => name) // Filter out any undefined names
    .join(", "); // Join names with a comma
    // console.log("Navigating with Card Details:", card, "Selected Department:", department, "Operator Full Name:", operatorFullName);
    navigate("/process-steps", { state: { cardDetails: card, department, operatorFullName, currentStepStatus } });
  };  

  // if (loading) return <Box display="flex" justifyContent="center" mt={5}><CircularProgress /></Box>;
  // if (error) return <Typography color="error">{error}</Typography>;

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
    <Box
      sx={{
        // height: "100vh", // Full viewport height
        // overflowY: "auto", // Vertical scrollbar
        // paddingLeft: "8px", // Reduced left padding
        // paddingRight: "8px", // Reduced right padding
        // paddingTop: "16px", // Top padding for spacing

        height: 670,
          width: '85%',
          marginLeft:"210px",
          marginRight:"150px",
          marginTop: "65px",
      }}
    >
                        <IconButton
                          sx={{
                            backgroundColor: grey[200],
                            color: "black",
                            "&:hover": { backgroundColor: grey[250] },
                            fontSize: "0.775rem",
                            height: "36px",
                            width: "36px",
                          }}
                          onClick={() => navigate(-1)}
                        >
                          <ArrowBack />
                        </IconButton>
      <Container
        sx={{
          padding: "0", // Remove default padding from the container
          maxWidth: "95%", // Reduce the width of the container
        }}
      >
        <Typography variant="h4" gutterBottom>
          Production Plan ID: {plan_id}
        </Typography>
        {/* Check if jobCards is empty and display a message if true */}
        {jobCards.length === 0 ? (
          <Typography variant="h6" color="error" align="center">
            No job card created yet for this production plan.
          </Typography>
        ) : (
        <Grid container spacing={3}>
          {jobCards.map((card) => (
            <Grid item xs={12} sm={6} md={4} key={card.job_card_id}>
              <Card
                sx={{
                  border: `2px solid ${grey[300]}`,
                  borderRadius: "8px",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  maxWidth: "350px",
                  margin: "0 auto",
                }}
                onClick={() => handleCardClick(card)} // Pass card details on click
              >
<CardContent sx={{ padding: "0" }}>
{/* Job Card Header */}
<Box
  display="flex"
  flexDirection="column"
  justifyContent="flex-start"
  sx={{
    backgroundColor: grey[100],
    padding: "8px",
    borderBottom: `2px solid ${grey[300]}`,
  }}
>
  <Box display="flex" justifyContent="space-between" alignItems="center">
  {/* <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "0.90rem" }}>
      Job Card ID: {card.job_card_id}
    </Typography> */}
    <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "0.90rem" }}>
      {formatJobCardId(card)}
    </Typography>
    <Chip
      label={card.job_card_status}
      sx={{
        backgroundColor: getStatusColor(card.job_card_status),
        color: "#fff",
        fontSize: "0.775rem",
      }}
    />
  </Box>

  <Box display="flex" sx={{ marginTop: "4px" }}>
    <Typography
      variant="body1"
      fontWeight="bold"
      sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
    >
      {card.product_name}:
    </Typography>
    <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
      {card.quantity} Units
    </Typography>
  </Box>

{/* <Box display="flex" sx={{ marginTop: "4px" }}>
  <Typography
    variant="body1"
    fontWeight="bold"
    sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
  >
    Assignee:
  </Typography>
  <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
    {card.current_operator_name ? (
      card.current_operator_name // Display the current operator name if assigned
    ) : (
      // Check if current_dept_name matches user.department
      card.current_dept_name === userDetails.department && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleDrawerOpen(card)}
          sx={{
            color: "white",
            fontSize: "0.675rem",
            textTransform: "none",
            padding: "4px 6px",
            minWidth: "35px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#00308F",
            "&:hover": {
              backgroundColor: "#8F5F00",
            },
            marginRight: "8px",
          }}
        >
          Assign
        </Button>
      )
    )}
  </Typography>
</Box> */}

<Box display="flex" sx={{ marginTop: "4px" }}>
  <Typography
    variant="body1"
    fontWeight="bold"
    sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
  >
    Assignee:
  </Typography>

  {/* <Typography
    variant="body1"
    fontWeight="bold"
    sx={{ color: grey[600], fontSize: "0.775rem", marginRight: "12px" }} // Added spacing
  >
    {card.current_operator_name}
  </Typography> */}

{/* <Typography
    variant="body1"
    fontWeight="bold"
    sx={{ color: grey[600], fontSize: "0.775rem", marginRight: "12px" }} // Added spacing
  > */}
    {/* {
      allUsers.find(user => user.id === card.current_operator_id)?.full_name || "Not assigned" // Display matched user's full name
    } */}
    {/* {
      allUsers.find(user => user.id === card.current_dept_status.find(operator => operator.operator_id)?.operator_id)?.full_name || "Not assigned"
    } */}
  {/* </Typography> */}

  {/* Collect all distinct operator names from current_dept_status */}
  {(() => {
    // Get all distinct operator IDs from current_dept_status
    const operatorIds = Array.from(
      new Set(
        card.current_dept_status
          .filter(op => op.operator_id) // Filter out any entries without an operator_id
          .map(op => op.operator_id) // Map to get an array of operator_ids
      )
    );
    // Find the full names of the distinct operators
    const operatorNames = operatorIds
      .map(id => allUsers.find(user => user.id === id)?.full_name) // Map to full names
      .filter(name => name) // Filter out any undefined names
      .join(", "); // Join names with a comma
    return (
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{ color: grey[600], fontSize: "0.775rem", marginRight: "12px" }} // Added spacing
      >
        {operatorNames || "Not assigned"} {/* Display names or "Not assigned" */}
      </Typography>
    );
  })()}

  <Button
    variant="outlined"
    size="small"
    onClick={() => handleDrawerOpen(card)}
    disabled={
      !userDetails.department || 
      !allUsers.some(user => user.department && user.department.split(',').some(dept => 
        userDetails.department && userDetails.department.split(',').map(d => d.trim()).includes(dept)
      )) ||
      !(isAdmin || (userDetails.department && userDetails.department.split(',').map(dept => dept.trim()).includes(card.current_dept_name)))
    }
    sx={{
      color: allUsers.some(user => user.department && user.department.split(',').some(dept => 
        userDetails.department && userDetails.department.split(',').map(d => d.trim()).includes(dept)
      ))  
        ? "white" 
        : grey[400],
      fontSize: "0.675rem",
      textTransform: "none",
      padding: "4px 6px",
      minWidth: "35px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: allUsers.some(user => user.department && user.department.split(',').some(dept => 
        userDetails.department && userDetails.department.split(',').map(d => d.trim()).includes(dept)
      ))  
        ? "#00308F" 
        : grey[300],
      "&:hover": {
        backgroundColor: allUsers.some(user => user.department && user.department.split(',').some(dept => 
          userDetails.department && userDetails.department.split(',').map(d => d.trim()).includes(dept)
        ))  
          ? "#8F5F00" 
          : grey[300],
      },
      marginRight: "8px",
    }}
>
    Assign
</Button>

</Box>

  <Box display="flex" sx={{ marginTop: "4px" }}>
    <Typography
      variant="body1"
      fontWeight="bold"
      sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
    >
      Current Department:
    </Typography>
    <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
      {card.current_dept_info}
    </Typography>
  </Box>

  {/* <Box display="flex" sx={{ marginTop: "4px" }}>
    <Typography
      variant="body1"
      fontWeight="bold"
      sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
    >
      Current Process:
    </Typography>
    <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
      {card.current_step_name}
    </Typography>
  </Box> */}

</Box>

                  {/* Card Content Section (Departments + Close Production Button) */}
                  <Box
                    sx={{
                        backgroundColor: "#fff",
                        padding: "8px",
                        borderBottom: `2px solid ${grey[300]}`,
                    }}
                    >
{/* Departments */}
{departments.map((department) => {
  // Check if there are steps for the current department
  const departmentSteps = card.steps.filter(step => step.dept_name === department.dept_name);
  
  // Determine if the department is completed or pending
  const isCompleted = departmentSteps.length > 0 && departmentSteps.every(step => step.step_status === "completed");
  const isPending = departmentSteps.length > 0 && departmentSteps.some(step => step.step_status === "pending");

  return (
    <Box
    key={department.dept_id} // Use dept_id as the key
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={1}
      sx={{
        padding: "6px",
        borderBottom: `1px solid ${grey[300]}`,
      }}
    >
      <Typography variant="body2" sx={{ fontSize: "0.775rem" }}>
        {department.dept_name}
      </Typography>

      {/* Conditional Rendering Based on department status */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: "auto", // Adjusted width to fit content
          height: "20px",
        }}
      >
        {isCompleted ? (
          <CheckCircle
            sx={{
              color: green[600],
              fontSize: "20px",
              marginRight: "8px", // Space between icons
            }}
            onClick={() => {
              
                handleArrowClick(card, department, department.dept_id); // Pass selectedDepartment
              
            }}
          />
        ) : isPending ? (
          // <ArrowForwardIcon
          //   sx={{
          //     color: isAdminForStep || card.current_dept_name === department.dept_name && allUsers.find(user => user.id === card.current_operator_id)?.full_name === userDetails.full_name ? blue[900] : grey[400],
          //     fontSize: "20px",
          //     marginRight: "8px",
          //     cursor: isAdminForStep || card.current_dept_name === department.dept_name && allUsers.find(user => user.id === card.current_operator_id)?.full_name === userDetails.full_name ? "pointer" : "not-allowed",
          //   }}
          //   onClick={() => {
          //     if (isAdminForStep || card.current_dept_name === department.dept_name && allUsers.find(user => user.id === card.current_operator_id)?.full_name === userDetails.full_name) {
          //       handleArrowClick(card, department, department.dept_id); // Pass selectedDepartment
          //     }
          //   }}
          // />
          <ArrowForwardIcon
            sx={{
              color: isAdminForStep || 
                    (card.current_dept_status.find(dept => dept.dept_name === department.dept_name) && 
                    allUsers.find(user => user.id === card.current_dept_status.find(operator => operator.operator_id)?.operator_id)?.full_name === userDetails.full_name) 
                    ? blue[900] : grey[400],
              fontSize: "20px",
              marginRight: "8px",
              cursor: isAdminForStep || 
                    (card.current_dept_status.find(dept => dept.dept_name === department.dept_name) && 
                    allUsers.find(user => user.id === card.current_dept_status.find(operator => operator.operator_id)?.operator_id)?.full_name === userDetails.full_name) 
                    ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (isAdminForStep || 
                  (card.current_dept_status.find(dept => dept.dept_name === department.dept_name) && 
                  allUsers.find(user => user.id === card.current_dept_status.find(operator => operator.operator_id)?.operator_id)?.full_name === userDetails.full_name)) {
                handleArrowClick(card, department, department.dept_id); // Pass selectedDepartment
              }
            }}
          />
        ) : null}
      </Box>
    </Box>
  );
})}
                    {/* Close Production Button + Vertical Dots Icon */}
                    <Box
                      sx={{
                        textAlign: "left",
                        mt: 1,
                        padding: "8px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: grey[200],
                          color: "black",
                          "&:hover": { backgroundColor: grey[250] },
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          fontSize: "0.775rem",
                          height: "36px",
                          textTransform: "none",
                        }}
                      >
                        Close Production
                      </Button>

                      {/* Vertical 3 Dots Icon */}
                      {/* <IconButton
                        sx={{
                          color: grey[600],
                          marginLeft: "10px",
                        }}
                      >
                        <MoreVert />
                      </IconButton> */}
                      <IconButton onClick={() => handleHistoryDrawerOpen(card)} sx={{ color: grey[600], marginLeft: "10px" }}>
                            <MoreVert />
                          </IconButton>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
         )}
        {/* <Box mt={4} textAlign="center">
          <Button variant="contained" color="secondary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </Box> */}
      </Container>

      {/* Drawer for DepartmentSteps */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{ style: { width: "30%" } }}
      >
        <Box p={2}>
        <Typography 
          variant="h5" 
          gutterBottom 
          style={{ fontWeight: 'bold' }} // Making the typography bold
        >
          Assign Operator
        </Typography>
        <Divider style={{ marginBottom: "20px" }} />
          <FormControl fullWidth>
          <InputLabel id="department-label">Department</InputLabel>
  <Select
    labelId="department-label"
    value={selectedDepartment || ""}
    onChange={handleDepartmentChange}
    label="Department"
    style={{ marginBottom: "20px" }}
  >
    {departments.map((dept) => {
      // <MenuItem key={dept.dept_id} value={dept.dept_id}>
      //   {dept.dept_name}
      // </MenuItem>
      // Check if selectedJobCard is defined and has current_dept_status
        const isDisabled = selectedJobCard?.current_dept_status && 
            !selectedJobCard.current_dept_status.some(status => status.dept_name === dept.dept_name);
        return (
            <MenuItem 
                key={dept.dept_name} 
                value={dept.dept_name} 
                disabled={isDisabled} // Disable if the department is not in current_dept_status
            >
                {dept.dept_name}
            </MenuItem>
        );
    })}
  </Select>
</FormControl>

{/* {operators.length > 0 && (
  <FormControl fullWidth>
    <InputLabel id="operator-label">Operator</InputLabel>
    <Select
      labelId="operator-label"
      value={selectedOperator || ""}
      onChange={(e) => setSelectedOperator(e.target.value)}
      label="Operator"
      style={{ marginBottom: "20px" }}
    >
      {operators.map((operator) => (
        <MenuItem key={operator.id} value={operator.id}>
          {operator.operator_name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)} */}

{/* Display the operator's full name from userDetails */}
<FormControl fullWidth>
            <InputLabel id="operator-label">Operator</InputLabel>
            <Select
              labelId="operator-label"
              value={selectedOperator || ""}
              onChange={(e) => setSelectedOperator(e.target.value)}
              label="Operator"
              style={{ marginBottom: "20px" }}
            >
              {operators.map((operator) => (
                <MenuItem key={operator.id} value={operator.id}>
                  {operator.full_name} {/* Display the full name */}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        
          <Box display="flex" justifyContent="space-between">
          <Button
  variant="contained"
  sx={{
    backgroundColor: "#714b67",
    "&:hover": {
      backgroundColor: "#604058", // Darker shade for hover effect
    },
  }}
  onClick={handleAssignOperator}
  disabled={!selectedOperator || !selectedDepartment}
>
  Assign Operator
</Button>
        <Button variant="contained" color="secondary" sx={{
          color: "#111827",
          backgroundColor: "#f9f9f9",
          "&:hover": {
            backgroundColor: "#fafafa", // Darker shade for hover effect
          },
        }}
        onClick={handleDrawerClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Drawer>

{/* Drawer for Job Card History */}
        {/* Drawer for Job Card History */}
        <Drawer anchor="bottom" open={historyDrawerOpen} onClose={handleHistoryDrawerClose}>
          <Box p={2} sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ backgroundColor: grey[100] }}>
              <IconButton onClick={handleHistoryDrawerClose} sx={{ color: grey[600] }}>
                <ArrowBack />
              </IconButton>
              {jobCardHistory.length > 0 ? (
                <Box display="flex" flexDirection="column" alignItems="center" sx={{ marginBottom: 2 }}>
                  <Typography variant="h6" gutterBottom>Job Card ID: {jobCardHistory[0].job_card_id}</Typography>
                  <Typography variant="body1">Created At: {new Date(jobCardHistory[0].created_date).toLocaleString()}</Typography>
                </Box>
              ) : (
                <Typography>No history available for this job card.</Typography>
              )}
              <Box sx={{ width: '36px' }} /> {/* Placeholder for alignment */}
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            {distinctHistory.length > 0 && (
              <Box>

{/* <Box display="flex" justifyContent="space-between" sx={{ marginBottom: 2 }}> */}
<Box sx={{ marginTop: "15px", marginBottom: "10px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
  <FormControl sx={{ width: '8%' }}>
    <InputLabel id="step-name-label">Step Name</InputLabel>
    <Select labelId="step-name-label" name="stepName" value={filters.stepName} onChange={handleFilterChange}>
      <MenuItem value="">All</MenuItem>
      {Array.from(new Set(distinctHistory.map(item => item.step_name))).map(step => <MenuItem key={step} value={step}>{step}</MenuItem>)}
    </Select>
  </FormControl>
  <FormControl sx={{ width: '6%' }}>
    <InputLabel id="status-label">Status</InputLabel>
    <Select labelId="status-label" name="status" value={filters.status} onChange={handleFilterChange}>
      <MenuItem value="">All</MenuItem>
      <MenuItem value="completed">Completed</MenuItem>
      <MenuItem value="pending">Pending</MenuItem>
      <MenuItem value="inprogress">In Progress</MenuItem>
    </Select>
  </FormControl>
  <FormControl sx={{ width: '11%' }}>
    <InputLabel id="operator-label">Assigned Operator</InputLabel>
    <Select labelId="operator-label" name="operator" value={filters.operator} onChange={handleFilterChange}>
      <MenuItem value="">All</MenuItem>
      {Array.from(new Set(distinctHistory.map(item => allUsers.find(user => user.id === item.operator_id)?.full_name))).map(operator => <MenuItem key={operator} value={operator}>{operator}</MenuItem>)}
    </Select>
  </FormControl>

  <TextField label="Start Date" type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} InputLabelProps={{ shrink: true }} sx={{ width: '9%' }} />
  <TextField label="End Date" type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} InputLabelProps={{ shrink: true }} sx={{ width: '9%' }} />
  <Button onClick={clearFilters}>Clear Filter</Button>
  <Button
    onClick={() => {
      const filtered = distinctHistory.filter(record => {
        const startDate = filters.startDate ? new Date(filters.startDate) : null;
        const endDate = filters.endDate ? new Date(filters.endDate) : null;
        const isWithinDateRange = (!startDate || new Date(record.start_time) >= startDate) &&
                                  (!endDate || new Date(record.start_time) <= endDate);
        return (
          (record.step_name.toLowerCase().includes(filters.stepName.toLowerCase()) || !filters.stepName) &&
          (record.step_status.toLowerCase().includes(filters.status.toLowerCase()) || !filters.status) &&
          (allUsers.find(user => user.id === record.operator_id)?.full_name.toLowerCase().includes(filters.operator.toLowerCase()) || !filters.operator) &&
          isWithinDateRange
        );
      });

      const excelHeaders = [
        'S/N',
        'Step',
        'Status',
        'Assigned Operator',
        'Start Time',
        'End Time',
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Job Card History');

      // Add header rows
      const titleRow = worksheet.addRow(['ARYAN EXPORTERS PVT. LTD.']);
      worksheet.mergeCells(`A1:F1`); // Merge cells A1 to F1
      titleRow.alignment = { horizontal: 'center', vertical: 'middle' }; // Center alignment

      // Set font for the merged cell
      const mergedTitleCell = worksheet.getCell('A1');
      mergedTitleCell.font = { bold: true, size: 14 }; // Set font for the merged cell

      const summaryRow = worksheet.addRow([`Summary Of Job Card History ${filters.startDate && filters.endDate ? `from ${filters.startDate} to ${filters.endDate}` : filters.startDate ? `on ${filters.startDate}` : 'for all dates'}`]);
      worksheet.mergeCells(`A2:F2`); // Merge cells A2 to F2
      summaryRow.alignment = { horizontal: 'center', vertical: 'middle' }; // Center alignment

      // Set font for the merged cell
      const mergedSummaryCell = worksheet.getCell('A2');
      mergedSummaryCell.font = { bold: true, size: 12 }; // Set font for the merged cell

      worksheet.addRow(excelHeaders).font = { bold: true };

      // Add data rows
      filtered.forEach((record, index) => {
        const startTime = new Date(record.start_time).toLocaleString(); // Format start time
        const endTime = record.end_time ? new Date(record.end_time).toLocaleString() : "In Progress"; // Format end time
        worksheet.addRow([
          index + 1,
          record.step_name || '', // Ensure empty values are handled
          record.step_status || '',
          allUsers.find(user => user.id === record.operator_id)?.full_name || '',
          startTime,
          endTime,
        ]);
      });

      // Apply styles to the worksheet
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          // Apply border to all cells, including empty ones
          cell.border = {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
          };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Bold for header rows
        if (rowNumber <= 2) {
          row.font = { bold: true };
        }
      });

      // Set column widths
      worksheet.getColumn(1).width = 5;   // S/N
      worksheet.getColumn(2).width = 20;  // Step
      worksheet.getColumn(3).width = 15;  // Status
      worksheet.getColumn(4).width = 20;  // Assigned Operator
      worksheet.getColumn(5).width = 25;  // Start Time
      worksheet.getColumn(6).width = 25;  // End Time

       // Save the workbook
              workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'JobCardHistory.xlsx');
              });
            }}
            startIcon={<SaveAltIcon />}
  >
    Export
  </Button>
  {/* <Button
    onClick={() => {
      const value = prompt("Enter search term:");
      if (value) {
        const filtered = distinctHistory.filter(record =>
          Object.values(record).some(field =>
            field && field.toString().toLowerCase().includes(value.toLowerCase())
          )
        );
        setFilters({
          stepName: '',
          status: '',
          operator: '',
          startDate: '',
          endDate: '',
        });
        setFilteredHistory(filtered);
      }
    }}
    startIcon={<Search />}
  >
    Search
  </Button> */}
</Box>

                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Step</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Assigned Operator</TableCell>
                        <TableCell>Start Time</TableCell>
                        <TableCell>End Time</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredHistory.map((historyItem) => {
                        const operatorName = allUsers.find(user => user.id === historyItem.operator_id)?.full_name || "Not assigned";
                        return (

                          <TableRow key={historyItem.history_id}>
                            <TableCell>{historyItem.step_name}</TableCell>
                            <TableCell>{historyItem.step_status}</TableCell>
                            <TableCell>{operatorName}</TableCell>
                            <TableCell>{new Date(historyItem.start_time).toLocaleString()}</TableCell>
                            <TableCell>{historyItem.end_time ? new Date(historyItem.end_time).toLocaleString() : "In Progress"}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            {/* <Button variant="contained" onClick={handleHistoryDrawerClose}>Close</Button> */}
          </Box>
        </Drawer>

    </Box>
    </div>
  );
};

export default ViewJobCard;
